import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import '@fontsource/dm-sans/400.css'
import '@fontsource/dm-sans/500.css'
import '@fontsource/dm-sans/600.css'
import '@fontsource/dm-sans/700.css'
import '@fontsource/anonymous-pro/400.css'
import '@fontsource/anonymous-pro/700.css'
import './index.css'
import './i18n/config'

import { App } from './app/app'
import { bootstrapSession } from './features/auth/bootstrap'
import { installTestSeam } from './features/database/rows/testSeam'
import { loadLithosConsent } from './shared/lib/lithos-consent'

const container = document.getElementById('root')
if (container === null) throw new Error('Missing #root element')

// Started first, so the banner loads alongside the session rather than after it.
void loadLithosConsent()

// The session is established before React mounts, not in a route guard. A guard
// runs per navigation and after the first render, so the app would paint a
// signed-out frame and then correct itself -- and every route would have to be
// written to tolerate a session that is still arriving.
await bootstrapSession()

// After the config is loaded, because the seam asks it whether it is wanted.
installTestSeam()

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
